// Dev only: forward console output to logs/dev-console.log. Must stay first.
import './utils/devConsoleBridge'
import { StrictMode, ReactNode } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// Self-hosted variable fonts (theme: Inter = body, Roboto = headings).
// Bundled by Vite — no external Google-Fonts request, so they cache offline.
import '@fontsource-variable/inter'
import '@fontsource-variable/roboto'
import App from './App'
import {
  registerServiceWorker,
  checkInstallability,
} from './serviceWorkerRegistration'

// Register service worker for PWA functionality (disabled in development)
if (import.meta.env.PROD) {
  registerServiceWorker()
  // Check if the app can be installed to homescreen
  checkInstallability()
}

interface WrapperProps {
  children: ReactNode
}

// Disable StrictMode in development for cleaner console output
// StrictMode intentionally double-renders components which causes duplicate logs
const AppWrapper = import.meta.env.DEV
  ? ({ children }: WrapperProps) => <>{children}</> // No StrictMode in development
  : StrictMode // Keep StrictMode in production

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <AppWrapper>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AppWrapper>
)
